import { ROUTER } from '@core/constants/router.constants';
import { administrationRouter } from '@modules/administration/administration.router';
import { authenticationRouter } from '@modules/authentication/authentication.router';
import { changemanRouter } from '@modules/changeman/changeman.router';
import { chefsAssistantRouter } from '@modules/chefs-assistant/chefs-assistant.router';
import { healthRouter } from '@modules/health/health.router';
import { helpDeskRouter } from '@modules/helpdesk/helpdesk.router';
import { mainRouter } from '@modules/main/main.router';
import { overviewRouter } from '@modules/overview/overview.router';
import Layout from '@shared/components/layout.component';
import { createBrowserRouter } from 'react-router';

export const router = createBrowserRouter([
  authenticationRouter,
  mainRouter,
  administrationRouter,
  changemanRouter,
  chefsAssistantRouter,
  healthRouter,
  helpDeskRouter,
  overviewRouter,
  {
    path: ROUTER.NOT_FOUND,
    element: (
      <Layout>
        <div className="gap-3 m-3 d-flex justify-content-center align-items-center">
          <i className="display-3 bi bi-file-earmark-x"></i>
          <div className="display-6 text-center">Rota não encontrada.</div>
        </div>
      </Layout>
    ),
  },
]);
